var _ellipse, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStateHorses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 120,
    viewBox: "0 0 144 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.9999,
    cy: 64.5865,
    rx: 55.4136,
    ry: 55.4136,
    fill: "#EDEEF0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2121_4673",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -8,
    width: 156,
    height: 128
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9437 58.26L23.2044 65.1718L0.335266 46.9938L19.3929 -3.72875L68.063 -7.24707L129.634 -2.26278L155.728 29.109L135.613 36.2202C140.567 44.5179 143.414 54.2195 143.414 64.5859C143.414 95.19 118.604 120 88.0002 120C57.3961 120 32.5866 95.19 32.5866 64.5859C32.5866 62.4468 32.7078 60.336 32.9437 58.26Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2121_4673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.131 0.375977C121.131 0.375977 119.35 5.49879 119.531 9.61147C119.713 13.7242 121.131 19.821 121.131 19.821C121.131 19.821 125.274 23.5729 130.654 36.7407C135.997 49.9085 136.797 53.0472 136.797 53.0472C136.797 53.0472 144.539 61.489 141.558 68.1991C138.578 74.8732 132.835 77.6511 127.092 75.4865C121.349 73.322 121.53 67.4415 121.53 67.4415C121.53 67.4415 116.769 66.8643 110.626 62.7156C104.483 58.5668 100.34 52.506 100.34 52.506C100.34 52.506 86.4548 62.1023 92.9974 78.4087C99.54 94.7151 107.064 100.415 105.283 112.032C103.502 123.648 102.702 124.406 102.702 124.406C102.702 124.406 17.2176 141.373 -2.01041 118.934C10.7688 84.6032 41.0927 52.4699 41.0927 52.4699L29.0253 57.9535C29.0253 57.9535 28.8435 41.4306 48.8348 24.7274C68.8261 8.02412 83.8741 8.2045 92.5976 8.60134C101.321 8.99818 106.264 11.3431 106.264 11.3431C106.264 11.3431 109.245 4.30828 121.131 0.375977Z",
    fill: "#CACBCD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateHorses);
export default __webpack_public_path__ + "static/media/empty-state-horses.18895f27.svg";
export { ForwardRef as ReactComponent };